export const ACCESS_TOKEN_KEY = "districtprinting_access_token";
export const ACCESS_TOKEN_EXPIRES_IN = 31556952000;
